module.exports = __webpack_public_path__ + "files/a4a8b617d1f6c75ad4bf17bafc2aec6a.mp3";


//////////////////
// WEBPACK FOOTER
// ./images/ring.mp3
// module id = 1405
// module chunks = 0